import { PAGE_PATH_HOME } from '@bluheadless/ui-logic/src/constants'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useCmsBlock } from '@bluheadless/ui-logic/src/hooks/cms/useCmsBlock'
import { useTheme } from '@mui/system'
import { useMediaQuery } from '@mui/material'
import { useIntl } from 'react-intl'
import ArrowheadLeftIcon from '../../../../atoms/icons/arrowhead-left-icon'
import Typography from '../../../../atoms/typography'
import Chip from '../../../../molecules/chip'
import Breadcrumbs from '../../../../organisms/breadcrumbs'
import SocialShare from '../../../../organisms/social-share'
import CmsBlock from '../../../../particles/cms-block'
import Block from '../../../../particles/cms-block/block'
import ImageArtDirection from '../../../../particles/art-direction'
import { BackButton, Content, HeadingWrapper, InnerContent, NavigationShare, Root, Tags, Title } from './blog.styled'

const MasterDataBlogPageComponent = ({
	title,
	contentBlockIdentifier,
	layout: { breadcrumbsVisible, headingVisible } = {},
	metadata,
}) => {
	const { formatMessage } = useIntl()
	const theme = useTheme()
	const mdUp = useMediaQuery(theme.breakpoints.up('md'))
	const {
		siteName,
		blog: { path },
	} = useConfig()

	const breadcrumbsItems = [
		{ title: formatMessage({ id: 'breadcrumbs_home' }), url: PAGE_PATH_HOME },
		{ title: formatMessage({ id: 'blog_page_title' }), url: path },
		{ title: title },
	]

	const { content } = useCmsBlock({ identifier: contentBlockIdentifier })

	const { blog_tags, blog_category } = metadata || {}

	const tags = blog_tags?.split(',') || []

	const image = metadata['blog_inner_image']
		? `contentmanager/content/${metadata['blog_inner_image']}`
		: metadata['blog_inner_image_src'] || null

	const imageMobile = metadata['blog_inner_image_m']
		? `contentmanager/content/${metadata['blog_inner_image_m']}`
		: metadata['blog_inner_image_m_src'] || null

	const imageSrc = !mdUp && imageMobile ? imageMobile : image
	const imageWidth =
		!mdUp && imageMobile
			? parseInt(metadata['blog_inner_image_m_width'], 10)
			: parseInt(metadata['blog_inner_image_width'], 10)
	const imageHeight =
		!mdUp && imageMobile
			? parseInt(metadata['blog_inner_image_m_height'], 10)
			: parseInt(metadata['blog_inner_image_height'], 10)

	return (
		<Root>
			<Content>
				{breadcrumbsVisible && mdUp && <Breadcrumbs items={breadcrumbsItems} mb={2} />}
				<HeadingWrapper>
					<NavigationShare>
						<BackButton
							StartIcon={ArrowheadLeftIcon}
							iconProps={{ fontSize: 'medium' }}
							href={path}
							variant="text"
							label={mdUp ? formatMessage({ id: 'back_button_label' }) : ''}
						/>
						<SocialShare title={title} media={imageSrc} />
					</NavigationShare>
					{blog_category && (
						<Typography component="h2" variant="subheadline2" color="grey.main" align="center" mb={5}>
							{blog_category}
						</Typography>
					)}
					{headingVisible && title && (
						<Title variant="h1" align="center">
							{title}
						</Title>
					)}
					{tags?.length > 0 && (
						<Tags>
							{tags?.map((tag) => (
								<Chip key={tag} label={formatMessage({ id: `blog_${tag}` })} />
							))}
						</Tags>
					)}
				</HeadingWrapper>
				{imageSrc && (
					<ImageArtDirection
						alt={title + ' | ' + siteName}
						originalWidth={imageWidth}
						originalHeight={imageHeight}
						sources={{
							xs: imageMobile ? imageMobile : image,
							...(image ? { md: image } : null),
						}}
					/>
				)}
				<InnerContent>{!!content && <Block content={content} />}</InnerContent>
			</Content>
			{metadata['blog_additional_block_id'] && <CmsBlock identifier={metadata['blog_additional_block_id']} />}
		</Root>
	)
}

MasterDataBlogPageComponent.defaultProps = {}

MasterDataBlogPageComponent.propTypes = {}

export default MasterDataBlogPageComponent
